import { useData } from "@hooks/useData";
import http from "@core/fetch";
import apiConfig from "@apiConfig";
import { components } from "@apiSchema";
import { ID } from "@models";
import { iReportProPublication, ReportProPublication } from "@models/ReportProPublication";

type CategoryProfileReportsResponse = components["schemas"]["SnapCategoryProfileReportsModel"];

const REQUEST_TYPE: keyof typeof apiConfig = "get category profile reports";

export function mapCategoryProfileReports(
    response: CategoryProfileReportsResponse,
): iReportProPublication[] {
    return (response.publications ?? [])
        .map(({ id, title, description, imageUrl, createDate }) =>
            new ReportProPublication({
                subModel: {
                    id: id ?? 0,
                    title: title ?? "",
                    description: description ?? "",
                    thumbnail: imageUrl ?? "",
                    createdDate: createDate ?? "",
                },
            }),
        );
}

async function getCategoryProfileReports(id: ID): Promise<iReportProPublication[]> {
    try {
        const response: CategoryProfileReportsResponse = await http.get(REQUEST_TYPE, { id });
        return mapCategoryProfileReports(response);
    } catch (error) {
        console.error("Fetch error:", REQUEST_TYPE, error);
        return [];
    }
}

export default function useCategoryProfileReports(id: ID) {
    return useData<iReportProPublication[]>([], getCategoryProfileReports, id);
}
